module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_nordland_pos.fc4f4437.pdf";